import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function HallRatesEditor({ onSaved }) {
  const [halls, setHalls] = useState([]);
  const [draft, setDraft] = useState({});
  const [saving, setSaving] = useState(false);

  const apply = (list) => {
    setHalls(list);
    setDraft(Object.fromEntries(list.map((h) => [h.key, String(h.rate)])));
  };
  useEffect(() => { api.get("/admin/gallery/hall-rates").then((r) => apply(r.data.halls)).catch(() => {}); }, []);

  const dirty = halls.some((h) => String(h.rate) !== draft[h.key]);

  const save = async () => {
    setSaving(true);
    try {
      const rates = Object.fromEntries(Object.entries(draft).map(([k, v]) => [k, parseInt(v, 10) || 0]));
      const r = await api.put("/admin/gallery/hall-rates", { rates });
      apply(r.data.halls);
      toast.success("Hall rates updated");
      onSaved?.();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail, "Failed to save rates"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="mt-8 border border-soft bg-white p-5" data-testid="hall-rates-editor">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="overline">Hall rates · per working day</div>
          <p className="text-xs text-muted2 mt-1">Applies to applications submitted after you save. Approved applications keep their fee.</p>
        </div>
        <button onClick={save} disabled={!dirty || saving} className="btn-primary disabled:opacity-50" data-testid="hall-rates-save">
          {saving ? "Saving…" : "Save rates"}
        </button>
      </div>
      <div className="mt-4 grid grid-cols-2 md:grid-cols-4 gap-4">
        {halls.map((h) => (
          <label key={h.key} className="block text-xs">
            <div className="mb-1 text-muted2 uppercase tracking-widest">{h.label}{h.ac ? " · A/C" : ""}</div>
            <input
              type="number" min={0} inputMode="numeric"
              value={draft[h.key] ?? ""}
              onChange={(e) => setDraft((d) => ({ ...d, [h.key]: e.target.value }))}
              className="w-full bg-transparent border-b border-soft py-2 font-serif text-lg"
              data-testid={`hall-rate-${h.key}`}
            />
          </label>
        ))}
      </div>
    </section>
  );
}
